import { render, staticRenderFns } from "./MarketingUniodonto.vue?vue&type=template&id=8946d6d6&"
import script from "./MarketingUniodonto.vue?vue&type=script&lang=js&"
export * from "./MarketingUniodonto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports